<template>
  <table class="table table-sm table-hover mt-0">
    <thead>
    <tr>
      <th></th>
      <th class="w_m_200">Препарат</th>
      <th></th>
      <th class="w_m_400"></th>
      <th>задачи</th>
      <th :class="{active: activeSorting === 'call'}">
        <i v-if="!options?.disable?.sorting" @click="sortRecords('call')"
           :class="{'icon-fa pointer': true,
            'icon-fa-sort-amount-asc': sorting.call.direction === 'asc',
            'icon-fa-sort-amount-desc': sorting.call.direction !== 'asc'}"></i>
        Спрос
      </th>
      <th :class="{active: activeSorting === 'price'}">
        <i v-if="!options?.disable?.sorting" @click="sortRecords('price')"
           :class="{'icon-fa pointer': true,
            'icon-fa-sort-amount-asc': sorting.price.direction === 'asc',
            'icon-fa-sort-amount-desc': sorting.price.direction !== 'asc'}"></i>
        Ср. цена
      </th>
      <th :class="{active: activeSorting === 'potential'}">
        <i v-if="!options?.disable?.sorting" @click="sortRecords('potential')"
           :class="{'icon-fa pointer': true,
            'icon-fa-sort-amount-asc': sorting.potential.direction === 'asc',
            'icon-fa-sort-amount-desc': sorting.potential.direction !== 'asc'}"></i>
        Потенциал
      </th>
      <th>Наличие</th>
      <th>Дата</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(r, i) in $currentListOfRecords" v-if="r" :key="r.stats_record_id">
      <td>{{ (i + 1) + (paginator ? ((paginator.current_page - 1) * paginator.per_page) : 0) }}</td>
      <td>
        <p>{{ r?.drug?.title || r.id }}</p>
        <p v-if="r?.drug" class="text-muted">{{ r?.drug?.group }}</p>
        <p v-if="(r?.statuses ?? []).length"><span class="badge badge-info">скрыт</span></p>
        <div v-html="getRecordComment(r)" class="comment_div"/>
      </td>
      <td>
        <template v-if="(r.all_tasks ?? []).length">
          <div class="flex flex_gap_10" v-if="options?.show?.taskResult">
            <div class="align-self-center">
              <LoadingButton
                title='Возобновить'
                className="btn btn-outline-success"
                :onClick="() => refreshTasks(r.id, r.all_tasks.map((t) => t.id))"
                :loading="loadingObject.btn.refreshTask[r.id]"
                type="button"
                :color="$constants.SUCCESS_COLOR"
              />
            </div>
            <TaskResult :activeRecord="r" :tasks="r.drug.scan_tasks"/>
          </div>
          <div v-else>
            <ScanFilters :records="r.drug.scan_tasks"/>
          </div>
        </template>
      </td>
      <td>
        <div v-for="d in (r?.drug?.related_drugs ?? [])" v-if="d?.drug?.id" class="flex align-items-center">
          <i @click="openDrugEdit(d.drug.id)" class="icon-fa icon-fa-edit mr-2 openEditDrugIcon"/>
          <span>{{ d.drug.title }}</span>
        </div>
        <LoadingButton
          v-if="false && !(r?.drug?.related_drugs ?? []).length && !(r.drug?.tasks ?? []).find((t) => t.type_id === 27)"
          title="задача привязать препараты РК"
          :loading="loadingObject.newPairTaskBtn[r.drug_id]"
          :color="$constants.SUCCESS_COLOR"
          :onClick="() => createTask(r.drug_id, 'pairDrug')"
          className="btn btn-xs btn-outline-success"
        />
      </td>
      <td>
        <div v-for="t in (r?.drug?.tasks ?? [])" class="mb-1">
          <template v-if="t.type_id === 22">
            <OutsorceCallTask :task="t" :record="r"/>
          </template>
        </div>
      </td>
      <td>{{ r.call }}</td>
      <td>
        <div class="flex flex_gap_10 align-items-center">
          <LoadStoreTrendData type="price" :record="r"/>
          <span>{{ r.price }}</span>
        </div>
      </td>
      <td>{{ Math.round(r.potential / 1000).toLocaleString('ru-RU') }}k</td>
      <td>
        <div class="flex flex_gap_10 align-items-center">
          <LoadStoreTrendData type="store" :trend="+r.store_trend" :record="r"/>
          <span>{{ r.stores }}</span>
        </div>
      </td>
      <td>
        {{ printDate(r.created_at, 'DD.MM.YYYY') }}
      </td>
      <td>
        <div class="flex flex-nowrap">
          <template v-if="!(r.all_tasks ?? []).length && !r.statuses.length">

          </template>
          <template v-else>
            <!--              v-if="false && !options?.disable?.hideButton"-->
            <LoadingButton
              v-if="r.statuses.length"
              :title="r.statuses.length ? `<i class='icon-fa icon-fa-power-off'/>` : 'Скрыть'"
              type="button"
              :loading="loadingObject.drugBtnLoading[r.drug.id]"
              :color="$constants.LOADING_COLOR"
              :onClick="() => updateVisibility(r.drug.id, !!(!r.statuses.length))"
              className="btn btn-outline-info"
            />
          </template>
          <button @click="newTaskModal(r)" class="btn btn-default" type="button">
            <i class="icon-fa icon-fa-edit"/>
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
import OutsorceCallTask from "@/components/drugs/tasks/OutsorceCallTask.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import ScanFilters from "@/views/statistics/components/tasksType/ScanFilters.vue";
import LoadStoreTrendData from "@/views/statistics/components/LoadStoreTrendData.vue";
import api from "@/api";
import {customUpdateData} from "@/eventsBus";
import TaskResult from "@/views/statistics/components/TaskResult.vue";

export default {
  props: ['paginator', 'options', 'refreshList'],
  components: {
    TaskResult,
    OutsorceCallTask,
    LoadingButton,
    ScanFilters,
    LoadStoreTrendData,
  },
  data() {
    return {
      activeSorting: 'call',
      sorting: {
        call: {direction: 'desc'},
        price: {direction: 'asc'},
        potential: {direction: 'asc'},
      },
      loadingObject: {
        btn: {
          refreshTask: {}
        },
        newPairTaskBtn: {},
        drugBtnLoading: {},
      },
    }
  },
  computed: {
    $currentListOfRecords() {
      return this.$store.getters["recordsList/list"];
    },
    $GlobalDrawerData() {
      return this.$store.getters["platform/globalDrawerData"];
    },
  },
  methods: {
    async refreshTasks(recordId, tasksIds) {
      console.log(recordId, tasksIds);
      this.$set(this.loadingObject.btn.refreshTask, recordId, true);
      for (let i = 0; i < tasksIds.length; i++) {
        await api.post('tasks/' + tasksIds[i], {
          action: 'reActive'
        });
      }
      toastr['success']('Сохранено');
      this.loadingObject.btn.refreshTask[recordId] = false;
      console.log('sent');
      this.$emit('updateList', []);
    },
    getRecordComment(record) {
      const c = record.details.find((d) => d.group === 'users_data' && d.alias === 'comment');
      return c ? c.value : null;
    },
    sortRecords(alias) {
      console.log(alias);
      this.activeSorting = alias;
      this.sorting[alias].direction = this.sorting[alias].direction === 'asc' ? 'desc' : 'asc';
      if (this.refreshList) {
        this.refreshList(alias);
      }
    },
    async updateVisibility(drugId, toHide) {
      // console.log(drugId, toHide);
      const index = this.$currentListOfRecords.findIndex((r) => r.drug_id === drugId)
      // console.log(this.$currentListOfRecords[index]);
      this.loadingObject.drugBtnLoading[drugId] = true;
      this.loadingObject.drugBtnLoading = {...this.loadingObject.drugBtnLoading};
      const {data} = await api.post('/statistics/003/codes', {
        action: 'updateStatus',
        status_type: 'hide_in_list',
        drug_id: drugId,
      })
      if (data.success) {
        customUpdateData.$emit('updateListById', this.$currentListOfRecords[index]?.id);
        toastr['success']('Сохранено', 'Успешно');
      }
      this.loadingObject.drugBtnLoading[drugId] = false;
    },
    openDrugEdit(drugId) {
      this.$store.dispatch('modals/setSideData', {drugId: drugId, type: 'editDrug'})
    },
    async createTask(drugId, alias = null) {
      this.loadingObject.newPairTaskBtn[drugId] = true;
      this.loadingObject.newPairTaskBtn = {...this.loadingObject.newPairTaskBtn};
      const tasks = {};
      tasks[alias] = {};
      switch (alias) {
        default:
          break;
      }
      const {data} = await api.post('/tasks/stat/new', {
        drug_id: drugId,
        tasks,
      });
      if (data.success) {
        const index = this.$currentListOfRecords.findIndex((r) => r.drug_id === drugId)
        customUpdateData.$emit('updateListById', this.$currentListOfRecords[index]?.id);
        toastr['success']('Сохранено!', 'Успешно');
      } else {
        toastr['warning'](data.message || 'Ошибка!');
      }
      this.loadingObject.newPairTaskBtn[drugId] = false;
    },
    newTaskModal(record) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {
          record,
          type: 'DrugStatisticMultiTask'
        },
        // callBackAction: 'refreshMSStatList'
      })
      this.$store.dispatch("recordsList/setActiveRecord", record);
    },
  }
}

</script>

<style scoped>

.w_m_200 {
  max-width: 200px;
}

.w_m_400 {
  max-width: 400px;
}

th.active {
  color: #007bff;
}

.openEditDrugIcon {
  color: white;
  background-color: #5bbfde;
  padding: 3px 4px;
  cursor: pointer;
  font-weight: 700;
  border-radius: 4px;
  text-align: center;
}

.comment_div {
  white-space: pre;
  font-size: 12px;
}
</style>
